import styled from 'styled-components'

const StyledEndButtonContainer = styled.div`
    margin-top: 1em;
    display: flex;
    justify-content: end;
    width: 100%;
`

export default StyledEndButtonContainer